import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Avatar from '@mui/joy/Avatar';
import List from '@mui/joy/List';
import ListDivider from '@mui/joy/ListDivider';
import ListItem from '@mui/joy/ListItem';
import ListItemButton, { listItemButtonClasses } from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';

export default function Mails({ data, emailIndex, sentEmailInd }: any) {

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: 'primary',
      },
      children: name ? `${name.slice(0, 2).toUpperCase()}` : "S"
    };
  }

  return (
<Box
  sx={{
    overflow: 'auto',
    maxHeight: 650,
    // Hide scrollbar for Chrome, Safari and Opera
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    // Hide scrollbar for IE, Edge and Firefox
    msOverflowStyle: 'none', // IE and Edge
    scrollbarWidth: 'none', // Firefox
  }}
>
      <List
        sx={{
          [`& .${listItemButtonClasses.root}.${listItemButtonClasses.selected}`]: {
            borderLeft: '2px solid',
            borderLeftColor: 'var(--joy-palette-primary-outlinedBorder)',
          },
        }}
      >
        {data.map((item: any, index: any) => (
          <React.Fragment key={index}>
            <ListItem onClick={() => sentEmailInd(index)}>
              <ListItemButton
                {...(index === emailIndex && {
                  selected: true,
                  color: 'neutral',
                })}
                sx={{ pl: 2, pr: 2, pt: 1, pb: 1 }}
              >
                <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
                <Avatar {...stringAvatar(item.receiveName)} />
                </ListItemDecorator>
                <Box sx={{ pl: 2, width: '100%' }}>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Typography level="body-xs">{item.subject}</Typography>
                      <Box
                        sx={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '99px',
                          bgcolor: item.color,
                        }}
                      />
                    </Box>
                    <Typography level="body-xs" textColor="text.tertiary">
                      {item.createdAt}
                    </Typography>
                  </Box>
                  <div>
                    <Typography level="title-sm" sx={{ mb: 0.5 }}>
                      {item.to}
                    </Typography>
                  </div>
                </Box>
              </ListItemButton>
            </ListItem>
            <ListDivider sx={{ m: 0 }} />
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
}
